// Supabase configuration
// These environment variables should be set in Vercel dashboard

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Helper function to get Supabase API base URL
export const getSupabaseApiUrl = (table) => {
  return `${SUPABASE_URL}/rest/v1/${table}`;
};

// Helper function to get Supabase headers
export const getSupabaseHeaders = () => {
  return {
    'Content-Type': 'application/json',
    'apikey': SUPABASE_ANON_KEY,
    'Authorization': `Bearer ${SUPABASE_ANON_KEY}`
  };
};

// Validate configuration
if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.warn('Supabase environment variables are not set. Please configure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your environment.');
}

export { SUPABASE_URL, SUPABASE_ANON_KEY };

